export interface RoleMapper {
  key: string;
  value: string;
}

export interface ConfigureIdpRequest {
  id?: string;
  name: string;
  displayName: string;
  emailAttributeName: string;
  samlMetadataUrl: string;
  samlMetadataFile: string;
  enableTaniumConsoleAuth: boolean;
  enableAccountPortalAuth: boolean;
  enableIdpSignout: boolean;
  domainNames: string[];
  roleMappers?: { [key: string]: RoleMapper };
}

export interface GetRolesResponse {
  roles: string[];
}

export interface GetIdpsResponse {
  data: IdpResponse[];
  nextPageCursor: string | null;
  totalCount: number;
}

export interface IdpResponse {
  id: string;
  name: string;
  displayName: string;
  emailAttributeName: string;
  samlMetadataUrl: string;
  samlMetadataFile: string;
  enableTaniumConsoleAuth: boolean;
  enableAccountPortalAuth: boolean;
  enableIdpSignout: boolean;
  domainNames: string[];
  roleMappers?: { [key: string]: RoleMapper };
}

export interface ValidateIdpRequest {
  url?: string;
  xml?: string;
}

export interface ValidateIdpResponse {
  result: boolean;
  message: string;
}

export interface SamlProviderConfig {
  entityID: string;
  url: string;
  logoutURL: string;
  expirationDate: string;
}

export enum MetadataType {
  Url = 'url',
  File = 'file',
}
